module.exports = __webpack_public_path__ + "img/dpq.53f3d786.png";